const initialState = {
  payload: null,
  loading: null,
};

export default initialState;
